<template>
  <div class="container">
    <div class="row">

      <div class="col-12 px-3 mt-2">
        <img :src="isFreeUser ? require('@/assets/logos/logo-free.png') : require('@/assets/logos/logo-vip.png')"  class="logo col-5" alt="logo" />
      </div>

      <div class="d-flex flex-column justify-content-center align-items-center col-12 mb-4 mt-4">
        <CarouselComponent :season="currentSeason" />
      </div>

      <div class="bold text-center mt-5">Please choose a</div>
      <div class="bold text-center">subscription package</div>

      <div class="normalText text-center mt-2">You are currently on the <span class="boldText"> free version</span> of</div>
      <div class="normalText text-center">Mzansi Rhythm. Join VIP for extra </div>
      <div class="normalText text-center">questions and more prizes.</div>

      <div class="rect mx-auto text-center mt-4 p-3 col-11"
           @click="selectPlan('daily')"
           :class="{ 'selected': selectedPlan === 'daily', 'disabled': isCurrentPlan(2) }">
        R5/Day
      </div>
      <div class="rect mx-auto text-center mt-2 p-3 col-11"
           @click="selectPlan('weekly')"
           :class="{ 'selected': selectedPlan === 'weekly', 'disabled': isCurrentPlan(3) }">
        R35/Week
      </div>
      <div class="rect mx-auto text-center mt-2 p-3 col-11"
           @click="selectPlan('monthly')"
           :class="{ 'selected': selectedPlan === 'monthly', 'disabled': isCurrentPlan(4) }">
        R45/Month
      </div>

      <div class="cancel text-center mt-4" @click="cancel">Cancel</div>

      <div class="normalText2 text-center mt-5">This is a subscription service. To manage your </div>
      <div class="normalText2 text-center">subscription click profile > manage subscription</div>
      <div class="normalText2 text-center terms" @click="Terms">Terms and Conditions</div>

    </div>
  </div>
</template>

<script>
import CarouselComponent from "@/views/components/CarouselComponent.vue";
import DepService from "@/api/services/depService";
import { mapState, mapMutations } from "vuex";
import { mtnServiceIdMap } from "@/config";

export default {
  name: "UpgradePackageView",
  components: {
    CarouselComponent
  },

  data() {
    return {
      selectedPlan: null,
    }
  },

  computed: {
    ...mapState(['user', 'productId', 'brandConfig', 'subscriptionType', 'isFreeUser','currentSeason'])
  },

  methods: {
    ...mapMutations(['setIsLoading', 'setSubscriptionType']),

    getServiceIdMapNumber(service) {
      return mtnServiceIdMap.get(service)
    },

    isCurrentPlan(pricePointId) {
      return this.getServiceIdMapNumber(this.user.serviceId) === pricePointId;
    },

    getCorrectServiceId(planType) {
      const serviceIdMap = {
        'daily': 10588,   // R5/Day
        'weekly': 10589,  // R35/Week
        'monthly': 10590  // R45/Month
      };

      return serviceIdMap[planType];
    },

    async selectPlan(planType) {
      // Check if this is the current plan
      const pricePointMap = {
        'daily': 2,
        'weekly': 3,
        'monthly': 4
      };

      if (this.isCurrentPlan(pricePointMap[planType])) {
        // Don't allow selection of current plan
        return;
      }

      this.selectedPlan = planType;
      this.setIsLoading(true);

      try {
        const serviceId = this.getCorrectServiceId(planType);

        // Call DOI One to initiate subscription
        const response = await DepService.doiOne(
            this.user.msisdn,
            serviceId,
            this.productId
        );

        this.setIsLoading(false);

        if (!response.data.user) {
          // Handle error
          this.$router.push(`/error/${response.data.reason}`);
          return;
        }

        // Store subscription ID for confirmation
        this.setSubscriptionType(response.data.user.subscription_id)

        // Navigate to confirmation with plan details and subscription ID
        setTimeout(() => {
          this.$router.push({
            path: '/package-confirmation',
            query: {
              plan: planType,
              subscriptionId: this.subscriptionType,
              serviceId: serviceId
            }
          });
        }, 100);

      } catch (error) {
        this.setIsLoading(false);
        console.error('Error initiating subscription:', error);
        this.$router.push('/profile');
      }
    },

    cancel() {
      this.$router.push('/upgrade');
    },
    Terms() {
      this.$router.push('/terms');
    },
  },
  beforeMount() {
    console.log("beforeMount");
  },
}
</script>

<style scoped>
.normalText {
  font-family: "Clash Display", sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  color: #000F56;
}

.normalText2 {
  font-family: "Clash Display", sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  color: #000F56;
}

.bold {
  font-family: "Clash Display", sans-serif;
  font-size: 19px;
  font-style: normal;
  font-weight: 600;
  color: #000F56;
}

.rect {
  border-radius: 30px;
  font-family: "Clash Display", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 19px;
  color: #000000;
  border: 2px solid #000000;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.cancel {
  font-family: "Clash Display", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  text-decoration: underline;
  text-decoration-color: black;
  cursor: pointer;
}

.rect.selected {
  background-color: #FFCB05;
  color: #000;
}

.rect:hover:not(.disabled) {
  background-color: #FFCB05;
  color: #000;
}

.rect.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #FFCB05;
}

.rect.disabled:hover {
  background-color: #FFCB05;
}

.terms{
  text-decoration: underline;
}
</style>